/**
 * Forwarding API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface TransportModeLookupDTO { 
    id?: number;
    description?: string;
    value?: TransportModeLookupDTO.ValueEnum;
}
export namespace TransportModeLookupDTO {
    export type ValueEnum = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
    export const ValueEnum = {
        NUMBER_0: 0 as ValueEnum,
        NUMBER_1: 1 as ValueEnum,
        NUMBER_2: 2 as ValueEnum,
        NUMBER_3: 3 as ValueEnum,
        NUMBER_4: 4 as ValueEnum,
        NUMBER_5: 5 as ValueEnum,
        NUMBER_6: 6 as ValueEnum,
        NUMBER_7: 7 as ValueEnum,
        NUMBER_8: 8 as ValueEnum,
        NUMBER_9: 9 as ValueEnum
    };
}